export const WEBHOOK_EVENTS = [
    "user.created",
    "user.login",
    "score.persisted",
    "ssq.post.created.after.transaction",
    "subscription.created",
    "subscription.plan.changed",
    "subscription.state.changed",
    "subscription.closed",
] as const;

export const webhookEventOptions = (currentEventName: string): string[] => {
    const options: string[] = [...WEBHOOK_EVENTS];

    return currentEventName !== "" && !options.includes(currentEventName) ? [...options, currentEventName] : options;
};
